export default "__VITE_ASSET__DpR$mGIW__"